module.exports = __webpack_public_path__ + "static/media/inProgressGif.a1a2e1a1.gif";